<div [class]="popupStyle">
  <button
    type="button"
    [id]="id"
    [attr.data-toggle]="toggle"
    [attr.aria-haspopup]="true"
    [attr.aria-expanded]="toggle"
    (click)="toggle = !toggle"
    [class]="btnStyleDefault">
    <span *ngIf="convertToIcon">
      <img [src]="iconSrc" class="user-icon" alt="dropdown" />
    </span>
    <span
      [class]="btnLabelDefault"
      [style.max-width.px]="btnFixSize"
      *ngIf="!convertToIcon"
      >{{ label }}</span
    >
  </button>
  <div
    [class]="dropMenuDefault"
    [ngClass]="{ 'dropdown-hide': toggle === false, 'dropdown-show': toggle }">
    <a
      class="dropdown-item"
      *ngFor="let item of list"
      (click)="onClick(item)"
      (keydown)="onClick(item)"
      tabindex="0"
      >{{ item.name }}</a
    >
  </div>
</div>
